const otpFieldLocalization = {
  characterLabel: (position: number, total: number) => `Character ${position} of ${total}`,
}

export default otpFieldLocalization
